import React, { useEffect, useState, useContext } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { generate2fa, verify2fa } from '../../services/GlobalApiService';
import { GlobalContext } from '../../contexts/GlobalContext';

export default function TwoFactorSetup({ userId }) {

  const { user } = useContext(GlobalContext);

  const [qrUrl, setQrUrl] = useState("");
  const [secret, setSecret] = useState("");
  const [code, setCode] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (!user) return;
    generate2fa(user.Username).then(data => {
      setQrUrl(data.qrCodeUrl);
      setSecret(data.secret);
    });
  }, [user]);

  const handleVerify = () => {
    verify2fa(user.Username, code)
      .then(data => {
        if (data.success) setStatus("2FA successfully enabled!");
        else setStatus("Invalid code. Try again.");
      });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 85 }}>
      <h2>Setup Two-Factor Authentication</h2>
      {qrUrl && <QRCodeSVG value={qrUrl} style={{ height: "200px", width: "200px" }} />}
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <label>Enter the 6-digit code from Google Authenticator:</label><br />
        <input
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          maxLength={6}
          style={{ marginTop: 10, padding: 5 }}
        />
        <div>
          <button className="btn btn-primary" onClick={handleVerify} style={{ marginTop: 10, padding: '5px 10px' }}>Verify</button>
        </div>
      </div>
      {status && <p style={{ marginTop: 15 }}>{status}</p>}
    </div>
  );
}